import React, { useEffect, useState } from "react";
import jsPDF from "jspdf";
import * as XLSX from "xlsx";
import moment from "moment";
import { useForm } from "react-hook-form";
import { useLocation } from "react-router-dom";
import { Form, FormGroup, Label, Row, Col, Alert, Table } from "reactstrap";
import {
  postMethod,
} from "../../../../_services/_postMethod";
import Loader from "../../../modules/loader";
import { showSuccessToast, showErrorToast } from "../../../../_services/notification";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const AddCustomerSales = (props) => {
  let queryParams = useQuery();
  const id = queryParams.get("id") == "" ? null : queryParams.get("id");
  const isView = queryParams.get("view") === "true";
  const websitelink = "https://admin.quicktagg.com/";
  const { register, handleSubmit, errors } = useForm();
  const [load, setLoad] = useState(false);
  const [loadInser, setLoadInsert] = useState(false);
  const [loadDelete, setLoadDelete] = useState(false);
  const [loadDeleteMsg, setLoadDeleteMsg] = useState("Deleted");
  const [loadSeachProduct, setLoadSeachProduct] = useState(false);
  const [customerRequired, setCustomerRequired] = useState(false);
  const [productsValidation, setProductsValidation] = useState(false);
  const [subcategory, setSubcategory] = useState([]);
  const [selectedSubCategory, setselectedSubCategory] = useState([]);
  const [productlist, setproductlist] = useState([]);
  const [seachProdutListLoading, setseachProdutListLoading] = useState(false);
  const [searchProduct, setSearchProduct] = useState("");
  const [selectedSubCategoryObject, setSelectedSubCategoryObject] = useState({
    mtran_id: "",
    category_id: "",
    subcategory_id: "",
    text: "",
    min_amount: "",
    max_amount: "",
  });
  const [param, setParam] = useState({
    tran_id: id == null ? "0" : id,
    entry_no: "",
    title: "",
    mobile: "",
    customer_id: "",
    customer_name: "",
    customer_sale_products: [],
    remarks: "",
  });
  const [success, setSuccess] = useState(false);
  const [successDelete, setSuccessDelete] = useState(false);
  const [isvalid, setIsValid] = useState({
    mobile: false,
    email: true,
  });
  const [valid, setValid] = useState({
    mobile: true,
    email: true,
  });

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        marginLeft: -10,
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 310,
      },
    },
  };

  const addData = () => {

    // Mobile Required Validation
    if (!param.mobile || param.mobile.length !== 10) {
      setCustomerRequired(true);
      showErrorToast("Please enter valid mobile number.");
      return;
    }

    setCustomerRequired(false);
    setLoadInsert(true);

    if (selectedSubCategory.length === 0) {
      setProductsValidation(true);
      setLoadInsert(false);
      return;
    }

    param.customer_sale_products = selectedSubCategory.map((item) => ({
      ...item,
      qty: parseInt(item.qty) || 1,
    }));

    postMethod("api/transactions/stockSales/insert", param).then((dataD) => {
      // console.log("Karan Testing ::: "+ JSON.stringify(param.customer_sale_products));
      var data = dataD.data[0];

      if (data.valid === true) {

        // Saving.. -> Saved
        setLoadInsert(false);
        setSuccess(true);

        try {
          exportToPDF();
        } catch (e) {
          console.error("PDF export error:", e);
        }

        setTimeout(() => {
          props.history.push("/branch/stock-sale");
        }, 1500);

      } else {
        setLoadInsert(false);
        showErrorToast(data.message || "Unable to save.");
      }
    });
  };

  const checkMobile = (val) => {
    setParam({ ...param, mobile: val });
    if (val.length !== 10) {
      setValid({ ...valid, mobile: false });
      setIsValid({ ...isvalid, mobile: false });
    } else {
      setValid({ ...valid, mobile: true });
      postMethod("api/transactions/customer/session/getCustomer", {
        mobile: val,
      }).then((dataD) => {
        var data = dataD.data[0];
        if (data) {
          setParam({
            ...param,
            customer_name: data.full_name,
            customer_id: data.customer_id,
            mobile: data.mobile,
          });
          setIsValid({ ...isvalid, mobile: false });
        } else {
          setParam({
            ...param,
            customer_name: "",
            customer_id: null,
            mobile: val,
          });

          setIsValid({ ...isvalid, mobile: true });
        }
      });
    }
  };

  const handleDelete = () => {
    var proceed = window.confirm("Do you Really Wish to Delete this Entry..?!");

    if (proceed) {
      setLoadDelete(true);
      postMethod("api/transactions/customer/session/delete", {
        tran_id: param.tran_id,
      }).then((data) => {
        if (data.data[0].valid) {
          setSuccessDelete(true);
          setTimeout(() => {
            props.history.push("/branch/customer/session");
          }, 2000);
        } else {
          setSuccessDelete(true);
          setTimeout(() => {
            setSuccessDelete(false);
          }, 4000);
          setLoadDeleteMsg(data.error);
          setLoadDelete(false);
        }
      });
    }
  };

  useEffect(() => {
    var selectCategory = [];
    postMethod("api/transactions/customer/session/getSubcategory", {
      branch_id: localStorage.getItem("jwl_branch_id"),
    }).then((data) => {
      setSubcategory(data.data);
      selectCategory = data.data;
    });
    setLoad(true);
    if (id !== null) {
      var temp = window.atob(id);
      postMethod("api/transactions/stockSales/preview", {
        tran_id: temp,
      }).then((dataD) => {
        var data = dataD.data[0];
        setParam({
          ...param,
          tran_id: temp,
          entry_no: data.entry_no,
          title: data.title,
          mobile: data.mobile,
          customer_id: data.customer_id,
          customer_name: data.customer_name,
          customer_sale_products: data.products,
          remarks: data.remarks,
        });
        setselectedSubCategory(data.products);

        let newselectedCategoryArr = [...data.products];
        for (
          let Mainindex = 0;
          Mainindex < selectCategory.length;
          Mainindex++
        ) {
          const elementMain = selectCategory[Mainindex];

          for (
            let logoindex = 0;
            logoindex < newselectedCategoryArr.length;
            logoindex++
          ) {
            const element = newselectedCategoryArr[logoindex];
            if (element.subcategory_id === elementMain.subcategory_id) {
              selectCategory[Mainindex].checked = "true";
            }
          }
        }
        setSubcategory([...selectCategory]);

        setLoad(false);
      });
    } else {
      postMethod("api/transactions/stockSales/preview", {
        tran_id: 0,
      }).then((dataD) => {
        var data = dataD.data[0];
        setParam({ ...param, entry_no: data.entry_no });
        setLoad(false);
      });
    }
  }, []);
  // check object is null or undefined
  const checkObject = (obj) => {
    return obj === undefined
      ? {}
      : Object.keys(obj).length === 0 && obj.constructor === Object;
  };

  // Add  Signle Product into Selected Array
  const AddProduct = (Obj) => {
    var tempIndex = selectedSubCategory.findIndex(
      (x) => x.product_id === Obj.product_id
    );

    var tempArry = [...selectedSubCategory];

    if (tempIndex > -1) {
      tempArry.splice(tempIndex, 1);
      setselectedSubCategory(tempArry);
    } else {
      var tempparam = {
        mtran_id: param.tran_id,
        category_id: Obj.category_id,
        subcategory_id: Obj.subcategory_id,
        product_id: Obj.product_id,
        product_code: Obj.product_code,
        product_name: Obj.product_name,
        color: Obj.color,
        size_length: Obj.size_length,
        gender: Obj.gender,
        price: Obj.price,
        qty: parseInt(Obj.sale_qty) || 1,
        url_image: Obj.url_image,
        image_path: Obj.image_path,
        isImageUrl: Obj.isImageUrl,

      };

      tempArry.push(tempparam);
      setselectedSubCategory(tempArry);
    }
  };
  // Add Or Remove ALL Product from arry
  const AddAllProduct = (checkAll) => {
    var tempArry = [...selectedSubCategory];

    if (checkAll) {
      productlist.forEach((Obj) => {

        if (parseInt(Obj.qty) <= 0) return;

        const saleQty = parseInt(Obj.sale_qty) || 1;

        if (saleQty > parseInt(Obj.qty)) {
          showErrorToast(
            `Sale Qty cannot be greater than Available Qty for ${Obj.product_code}`
          );
          return;
        }

        var tempIndex = tempArry.findIndex(
          (x) => x.product_id === Obj.product_id
        );

        if (tempIndex === -1) {
          tempArry.push({
            mtran_id: param.tran_id,
            category_id: Obj.category_id,
            subcategory_id: Obj.subcategory_id,
            product_id: Obj.product_id,
            product_code: Obj.product_code,
            product_name: Obj.product_name,
            gender: Obj.gender,
            color: Obj.color,
            size_length: Obj.size_length,
            price: Obj.price,
            qty: saleQty,
            url_image: Obj.url_image,
            image_path: Obj.image_path,
            isImageUrl: Obj.isImageUrl,
          });
        }
      });
    } else {
      productlist.forEach((Obj) => {
        const tempIndex = tempArry.findIndex(
          (x) => x.product_id === Obj.product_id
        );

        if (tempIndex > -1) {
          tempArry.splice(tempIndex, 1);
        }
      });
    }

    setselectedSubCategory(tempArry);
  };
  const SearchProduct = () => {
    setLoadSeachProduct(true);
    if (
      selectedSubCategoryObject.subcategory_id !== "" &&
      selectedSubCategoryObject.max_amount !== "" &&
      selectedSubCategoryObject.min_amount !== ""
    ) {
      postMethod("api/transactions/customer/session/getProducts", {
        subcategory_id: selectedSubCategoryObject.subcategory_id,
        min_amount: selectedSubCategoryObject.min_amount,
        max_amount: selectedSubCategoryObject.max_amount,
      }).then((data) => {
        setproductlist(data.data);
      });
    }
    setLoadSeachProduct(false);
  };

  const removeProduct = (i) => {
    let tempArry = [...selectedSubCategory];
    tempArry.splice(i, 1);
    setselectedSubCategory(tempArry);
  };

  // const searchProductFun = () => {
  //   setseachProdutListLoading(true);
  //   postMethod("api/transactions/customer/session/getProductsbyProductCode", {
  //     search: searchProduct,
  //   }).then((data) => {
  //     setproductlist(data.data);
  //     setseachProdutListLoading(false);
  //   });
  // };
  const searchProductFun = () => {
    setseachProdutListLoading(true);

    postMethod("api/transactions/customer/session/getProductsbyProductCode", {
      search: searchProduct,
    }).then((data) => {

      if (!data.data || data.data.length === 0) {
        setproductlist([]);
        showErrorToast("Product does not exist.");
      } else {

        const products = data.data.map(item => ({
          ...item,
          sale_qty: 1      // <-- har new search pe reset
        }));

        setproductlist(products);
      }

      setseachProdutListLoading(false);
    });
  };

  const getImage = (item) => {
    if (!item) return "";
    let path = item.image_path || "";
    let baseUrl = item.url_image || "https://admin.quicktagg.com/";

    if (item.isImageUrl === true || item.isImageUrl === "true") {
      if (path.startsWith("http://") || path.startsWith("https://") || path.startsWith("data:")) {
        return path;
      }
      return baseUrl.replace(/\/$/, "") + "/" + path.replace(/^\//, "");
    }

    if (path.startsWith("http://") || path.startsWith("https://") || path.startsWith("data:")) {
      return path;
    }

    return baseUrl.replace(/\/$/, "") + "/" + path.replace(/^\//, "");
  };

  const loadImageAsBase64 = async (src) => {
    if (!src) return null;
    try {
      const res = await fetch(src);
      if (res.ok) {
        const blob = await res.blob();
        return await new Promise((resolve) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = () => resolve(null);
          reader.readAsDataURL(blob);
        });
      }
    } catch (e) {}

    return new Promise((resolve) => {
      const corsSrc = src.includes("data:") ? src : src + (src.includes("?") ? "&" : "?") + "cb=" + Date.now();
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.onload = () => {
        try {
          const canvas = document.createElement("canvas");
          canvas.width = img.naturalWidth || img.width || 60;
          canvas.height = img.naturalHeight || img.height || 60;
          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
          const dataUrl = canvas.toDataURL("image/jpeg", 0.85);
          resolve(dataUrl);
        } catch (e) {
          resolve(null);
        }
      };
      img.onerror = () => resolve(null);
      img.src = corsSrc;
    });
  };

  const exportToExcel = () => {
    try {
      const sheetData = [
        ["Entry No.", param.entry_no || "-"],
        ["Title", param.title || "-"],
        ["Mobile", param.mobile || "-"],
        ["Customer Name", param.customer_name || "-"],
        ["Remarks", param.remarks || "-"],
        [],
        [`Selected Products (${selectedSubCategory.length} Items)`],
        ["Product Code", "Name", "Gender", "Color", "Size", "Price", "Qty"],
        ...selectedSubCategory.map((item) => [
          item.product_code || "",
          item.product_name || "",
          item.gender || "",
          item.color || "",
          item.size_length || "",
          item.price ? `₹ ${item.price}` : "",
          item.qty ?? "",
        ]),
      ];

      const worksheet = XLSX.utils.aoa_to_sheet(sheetData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Customer_Sales");
      const filename = `Customer_Sales_${param.entry_no || param.tran_id || "Details"}_${moment().format("DD-MM-YYYY")}.xlsx`;
      XLSX.writeFile(workbook, filename);
      showSuccessToast("Excel downloaded successfully.");
    } catch (err) {
      console.error(err);
      showErrorToast("Error generating Excel file.");
    }
  };

  const exportToPDF = async () => {
    try {
      setLoad(true);
      const pdf = new jsPDF("p", "mm", "a4");
      let y = 15;

      const formattedDate = param.date ? moment(param.date).format("DD-MM-YYYY") : moment().format("DD-MM-YYYY");

      // Title & Header
      pdf.setFontSize(15);
      pdf.setFont(undefined, "bold");
      pdf.text("CUSTOMER SALE RECEIPT", 14, y);

      pdf.setFontSize(9);
      pdf.setFont(undefined, "normal");
      pdf.text(`Date: ${formattedDate}`, 196, y, { align: "right" });
      y += 6;

      // Divider line
      pdf.setDrawColor(200, 200, 200);
      pdf.line(14, y, 196, y);
      y += 7;

      // Details Grid (Full A4 Spacing)
      pdf.setFontSize(10);
      pdf.setFont(undefined, "bold");
      pdf.text("Customer Details:", 14, y);
      pdf.text("Sale Info:", 110, y);
      y += 6;

      pdf.setFontSize(9);
      pdf.setFont(undefined, "normal");
      pdf.text(`Customer Name: ${param.customer_name || "-"}`, 14, y);
      pdf.text(`Entry No.: ${param.entry_no || "-"}`, 110, y);
      y += 5;
      pdf.text(`Mobile: ${param.mobile || "-"}`, 14, y);
      pdf.text(`Title: ${param.title || "-"}`, 110, y);
      y += 5;
      if (param.remarks) {
        pdf.text(`Remarks: ${param.remarks}`, 14, y);
        y += 5;
      }

      y += 5;
      pdf.setFont(undefined, "bold");
      pdf.setFontSize(10);
      pdf.text(`Product Details (${selectedSubCategory.length} Items)`, 14, y);
      y += 6;

      // Table Header Row (A4 Width: 182mm spanning x=14 to x=196)
      pdf.setFontSize(9);
      pdf.setFillColor(240, 243, 246);
      pdf.rect(14, y - 4, 182, 7, "F");

      const colPositions = [16, 26, 65, 105, 125, 145, 163, 182];
      const headers = ["#", "Product Code", "Name", "Gender", "Color", "Size", "Price", "Qty"];
      headers.forEach((h, idx) => {
        pdf.text(h, colPositions[idx], y);
      });

      y += 4;
      pdf.line(14, y, 196, y);
      y += 6;

      // Table Body Rows
      let totalQty = 0;
      let totalPrice = 0;

      pdf.setFont(undefined, "normal");
      for (let index = 0; index < selectedSubCategory.length; index++) {
        const item = selectedSubCategory[index];
        const rowHeight = 7;

        if (y + rowHeight > 275) {
          pdf.addPage();
          y = 15;
        }

        const qtyVal = parseInt(item.qty) || 1;
        const priceVal = parseFloat(item.price) || 0;
        totalQty += qtyVal;
        totalPrice += priceVal * qtyVal;

        pdf.text(String(index + 1), colPositions[0], y);
        pdf.text(String(item.product_code || "-"), colPositions[1], y, { maxWidth: 36 });
        pdf.text(String(item.product_name || "-"), colPositions[2], y, { maxWidth: 38 });
        pdf.text(String(item.gender || "-"), colPositions[3], y, { maxWidth: 18 });
        pdf.text(String(item.color || "-"), colPositions[4], y, { maxWidth: 18 });
        pdf.text(String(item.size_length || "-"), colPositions[5], y, { maxWidth: 16 });
        pdf.text(item.price ? `₹ ${item.price}` : "-", colPositions[6], y, { maxWidth: 16 });
        pdf.text(String(qtyVal), colPositions[7], y, { maxWidth: 12 });

        y += rowHeight;
      }

      // Summary Footer Line
      pdf.line(14, y, 196, y);
      y += 6;

      pdf.setFont(undefined, "bold");
      pdf.text(`Total Items: ${selectedSubCategory.length} | Total Qty: ${totalQty}`, 14, y);
      if (totalPrice > 0) {
        pdf.text(`Total Amount: ₹ ${totalPrice.toFixed(2)}`, 196, y, { align: "right" });
      }

      const filename = `Customer_Sales_${param.entry_no || param.tran_id || "Receipt"}_${moment().format("DD-MM-YYYY")}.pdf`;
      pdf.save(filename);
      showSuccessToast("PDF generated successfully.");
    } catch (err) {
      console.error(err);
      showErrorToast("Error generating PDF file.");
    } finally {
      setLoad(false);
    }
  };
  return (
    <>
      {load ? <Loader /> : null}
      <Form onSubmit={handleSubmit(addData)} className="customer-sales-editor-form">
        <div className="card card-custom gutter-b customer-sales-editor-card">
          <div className="card-header customer-sales-editor-header d-flex align-items-center justify-content-between flex-wrap">
            <div className="card-title customer-sales-editor-title">
              <span className="customer-sales-editor-icon">
                <i className="fas fa-shopping-bag" />
              </span>
              <div>
                <h3 className="card-label">{isView ? "View" : id != null ? "Edit" : "Add"} Customer Sales</h3>
                <p>Record customer purchase details and selected products.</p>
              </div>
            </div>
            {isView && (
              <div className="d-flex align-items-center flex-wrap mb-2" style={{ gap: "10px" }}>
                <button
                  type="button"
                  className="btn btn-outline-danger btn-sm font-weight-bold py-2 px-3"
                  onClick={exportToPDF}
                >
                  <i className="fa fa-file-pdf-o mr-2"></i> Download PDF
                </button>
                <button
                  type="button"
                  className="btn btn-outline-success btn-sm font-weight-bold py-2 px-3"
                  onClick={exportToExcel}
                >
                  <i className="fa fa-file-excel-o mr-2"></i> Download Excel
                </button>
              </div>
            )}
          </div>
          <div className="card-body customer-sales-editor-body">
            <Row className="customer-sales-editor-grid">
              <Col sm={4}>
                <FormGroup>
                  <Label>Entry No.</Label>
                  <input
                    type="text"
                    required
                    value={param.entry_no}
                    disabled={isView || id != null}
                    className="form-control h-auto py-2 px-6"
                    name="entry_no"
                    onChange={(e) =>
                      setParam({
                        ...param,
                        entry_no: e.target.value,
                      })
                    }
                    ref={register}
                  />
                </FormGroup>
              </Col>
              <Col sm={4}>
                <FormGroup>
                  <Label>Title</Label>
                  <input
                    type="text"
                    required
                    value={param.title}
                    disabled={isView}
                    className="form-control h-auto py-2 px-6"
                    name="title"
                    onChange={(e) =>
                      setParam({
                        ...param,
                        title: e.target.value,
                      })
                    }
                    ref={register}
                  />
                </FormGroup>
              </Col>
              <Col sm={4}>
                <FormGroup>
                  <Label>
                    Mobile{" "}
                    {customerRequired && (
                      <span className="form-text text-danger">
                        Mobile number is required
                      </span>
                    )}
                  </Label>
                  <input
                    type="number"
                    value={param.mobile}
                    disabled={isView}
                    className="form-control h-auto py-2 px-6"
                    name="mobile"
                    onChange={(e) => checkMobile(e.target.value)}
                    ref={register}
                  />
                  {!valid.mobile && (
                    <span className="form-text text-danger">
                      Please enter valid mobile
                    </span>
                  )}
                  {isvalid.mobile && (
                    <span className="form-text text-danger">
                      This Mobile number not registered
                    </span>
                  )}
                </FormGroup>
              </Col>
              <Col sm={4}>
                <FormGroup>
                  <Label>Customer Name</Label>
                  <input
                    type="text"
                    required
                    disabled
                    value={param.customer_name}
                    className="form-control h-auto py-2 px-6"
                    name="customer_name"
                    onChange={(e) =>
                      setParam({ ...param, customer_name: e.target.value })
                    }
                    ref={register}
                  />
                </FormGroup>
              </Col>

              <Col sm={6}>
                <FormGroup>
                  <Label>Remarks</Label>
                  <textarea
                    value={param.remarks}
                    disabled={isView}
                    className="form-control h-auto py-2 px-6"
                    name="remarks"
                    onChange={(e) =>
                      setParam({ ...param, remarks: e.target.value })
                    }
                    ref={register}
                  />
                </FormGroup>
              </Col>
            </Row>

            <Row className="customer-sales-editor-section">
              {!isView && (
                <>
                  <Col sm={12} md={5}>
                    <div className="customer-sales-editor-section-title">
                      <span>
                        <i className="fas fa-search" />
                      </span>
                      <div>
                        <h4>Searched Products</h4>
                        <p>Search by product code and choose items for this sale.</p>
                      </div>
                    </div>
                  </Col>
                  <Col sm={12} md={7}>
                    <FormGroup className="customer-sales-editor-search">
                      <input
                        type="text"
                        placeholder="Search by product code"
                        value={searchProduct}
                        className="form-control h-auto py-2 px-6"
                        name="search"
                        onChange={(e) => setSearchProduct(e.target.value)}
                      />
                      {seachProdutListLoading ? (
                        <button type="button" className="btn btn-info customer-sales-editor-inline-btn">
                          Searching..
                        </button>
                      ) : (
                        <button
                          type="button"
                          className="btn btn-success customer-sales-editor-inline-btn"
                          onClick={() => {
                            searchProductFun();
                          }}
                        >
                          Search
                        </button>
                      )}
                    </FormGroup>
                  </Col>
                  <Col sm={12}>
                    <div className="customer-sales-editor-table-wrap">
                      <Table bordered className="customer-sales-editor-table">
                        <thead>
                          <tr>
                            <th width="12%">Product Code </th>
                            <th>Product Name</th>
                            <th>Gender</th>
                            <th>Color</th>
                            <th>Size</th>
                            <th>Price</th>
                            <th width="10%">Available Qty</th>
                            <th width="10%">Qty</th>
                            <th>Image</th>
                            <th className="customer-sales-editor-all-head">
                              ALL{" "}
                              <input
                                type="checkbox"
                                className="mt-2 ml-2"
                                name="available"
                                onChange={(e) => {
                                  AddAllProduct(e.target.checked);
                                }}
                              />
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {productlist.length > 0 ? (
                            productlist.map((obj, i) => {
                              return (
                                <tr key={i}>
                                  <td>
                                    ({i + 1}) {obj.product_code}
                                  </td>
                                  <td>{obj.product_name}</td>
                                  <td>{obj.gender}</td>
                                  <td>{obj.color}</td>
                                  <td>{obj.size_length}</td>
                                  <td>{obj.price}</td>
                                  <td>{obj.qty}</td>
                                  <td>
                                    <input
                                      type="number"
                                      className="form-control"
                                      value={obj.sale_qty}
                                      onFocus={(e) => {
                                        if (obj.sale_qty === 1) {
                                          const temp = [...productlist];
                                          temp[i].sale_qty = "";
                                          setproductlist(temp);
                                        }
                                      }}
                                      onBlur={(e) => {
                                        let val = e.target.value;
                                        if (val === "" || Number(val) < 1) val = 1;
                                        if (Number(val) > Number(obj.qty)) val = obj.qty;
                                        const temp = [...productlist];
                                        temp[i].sale_qty = val;
                                        setproductlist(temp);
                                      }}
                                      onChange={(e) => {
                                        let value = e.target.value;

                                        if (value !== "" && Number(value) < 1) value = 1;
                                        if (value !== "" && Number(value) > Number(obj.qty)) {
                                          value = obj.qty;
                                          showErrorToast("Qty can not be more then available qty.");
                                        }

                                        const temp = [...productlist];
                                        temp[i].sale_qty = value;
                                        setproductlist(temp);

                                        if (value === "") {
                                          const selectedIndex = selectedSubCategory.findIndex(
                                            (x) => x.product_id === obj.product_id
                                          );

                                          if (selectedIndex > -1) {
                                            const tempSelected = [...selectedSubCategory];
                                            tempSelected[selectedIndex].qty = "";
                                            setselectedSubCategory(tempSelected);
                                          }

                                          return;
                                        }

                                        const qty = parseInt(value);
                                        const selectedIndex = selectedSubCategory.findIndex(
                                          (x) => x.product_id === obj.product_id
                                        );

                                        if (selectedIndex > -1) {
                                          const tempSelected = [...selectedSubCategory];
                                          tempSelected[selectedIndex].qty = qty;
                                          setselectedSubCategory(tempSelected);
                                        }
                                      }}
                                    />
                                  </td>
                                  <td>
                                    {obj.isImageUrl === true || obj.isImageUrl === "true" ? (
                                      <img src={obj.image_path} width="36px" />
                                    ) : (
                                      <img src={obj.url_image + obj.image_path} width="36px" />
                                    )}
                                    {/* <img
                                src={obj.url_image + "" + obj.image_path}
                                width="36px"
                                alt=""
                              />{" "} */}
                                  </td>

                                  <td>
                                    <input
                                      type="checkbox"
                                      disabled={parseInt(obj.qty) <= 0}
                                      checked={
                                        selectedSubCategory.findIndex(
                                          (e) => e.product_id === obj.product_id
                                        ) > -1
                                          ? true
                                          : false
                                      }
                                      className="form-control h-auto py-2 px-6"
                                      name="available"
                                      onChange={(e) => {
                                        // if (e.target.checked) {

                                        //   const saleQty = parseInt(obj.sale_qty) || 1;

                                        //   if (saleQty > obj.qty) {
                                        //     showErrorToast("Qty is not more then available qty.");
                                        //     return;
                                        //   }

                                        //   AddProduct({
                                        //     ...obj,
                                        //     sale_qty: saleQty,
                                        //   });

                                        // }
                                        if (e.target.checked) {

                                          if (parseInt(obj.qty) <= 0) {
                                            showErrorToast("Stock not available.");
                                            return;
                                          }

                                          const saleQty =
                                            obj.sale_qty === "" || obj.sale_qty === undefined
                                              ? 1
                                              : parseInt(obj.sale_qty);

                                          if (saleQty > obj.qty) {
                                            showErrorToast("Qty is not more than available qty.");
                                            return;
                                          }

                                          AddProduct({
                                            ...obj,
                                            sale_qty: saleQty,
                                          });

                                        }
                                        else {

                                          const tempArry = [...selectedSubCategory];
                                          const index = tempArry.findIndex(
                                            (x) => x.product_id === obj.product_id
                                          );

                                          if (index > -1) {
                                            tempArry.splice(index, 1);
                                            setselectedSubCategory(tempArry);
                                          }
                                        }
                                      }}
                                    />
                                  </td>
                                </tr>
                              );
                            })
                          ) : (
                            <tr>
                              <td colSpan="8" className="text-center customer-sales-editor-empty">
                                No Data
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                    </div>
                  </Col>
                </>)}

              {selectedSubCategory.length > 0 ? (
                <Col sm={12}>
                  <div className="customer-sales-editor-selected-title">
                    <h4>Selected Products</h4>
                    <span>{selectedSubCategory.length} Items</span>
                  </div>
                  <div className="customer-sales-editor-table-wrap">
                    <Table bordered className="customer-sales-editor-table customer-sales-editor-selected-table">
                      <thead>
                        <tr>
                          <th>S.No</th>
                          <th width="12%">Product Code </th>
                          <th>Product Name</th>
                          <th>Gender</th>
                          <th>Color</th>
                          <th>Size</th>
                          <th>Price</th>
                          <th>qty</th>
                          <th>Image</th>
                          {isView ? null : <th>Action</th>}
                        </tr>
                      </thead>
                      <tbody>
                        {selectedSubCategory.length > 0
                          ? selectedSubCategory.map((obj, i) => {
                            return (
                              <tr key={i}>
                                <td>{i + 1}</td>
                                <td>
                                  {obj.product_code}
                                </td>
                                <td>{obj.product_name}</td>
                                <td>{obj.gender}</td>
                                <td>{obj.color}</td>
                                <td>{obj.size_length}</td>
                                <td>{obj.price}</td>
                                <td>{obj.qty}</td>
                                <td>
                                  {/* <img
                                    src={obj.url_image + "" + obj.image_path}
                                    width="36px"
                                    alt=""
                                  />{" "} */}
                                  {obj.isImageUrl === true || obj.isImageUrl === "true" ? (
                                    <img src={obj.image_path} width="36px" />
                                  ) : (
                                    <img src={obj.url_image + obj.image_path} width="36px" />
                                  )}
                                </td>
                                {isView ? null : <td>
                                  <button
                                    type="button"
                                    className="customer-sales-editor-remove-btn"
                                    onClick={() => removeProduct(i)}
                                  >
                                    x
                                  </button>
                                </td>}
                              </tr>
                            );
                          })
                          : null}
                      </tbody>
                    </Table>
                  </div>
                </Col>
              ) : null}
            </Row>

            {success ? <Alert color="success">Saved Successfully</Alert> : null}
            {successDelete ? (
              <Alert color="danger">{loadDeleteMsg}</Alert>
            ) : null}
          </div>
          <div className="card-footer customer-sales-editor-footer">
            <a
              href="/branch/stock-sale"
              className="btn btn-secondary mr-2 customer-sales-editor-cancel-btn"
            >
              {isView ? "Back" : "Cancel"}
            </a>
            {!isView && id &&
              (loadDelete ? (
                <button type="button" className="btn btn-danger mr-2 customer-sales-editor-action-btn">
                  Deleting..
                </button>
              ) : (
                <button
                  type="button"
                  onClick={handleDelete}
                  className="btn btn-danger mr-2 customer-sales-editor-action-btn"
                >
                  Delete
                </button>
              ))}

            {!isView && (loadInser ? (
              <button type="button" className="btn btn-primary customer-sales-editor-action-btn">
                Saving...
              </button>
            ) : success ? (
              <button type="button" className="btn btn-success customer-sales-editor-action-btn">
                Saved
              </button>
            ) : (
              <button type="submit" className="btn btn-primary customer-sales-editor-action-btn">
                Save
              </button>
            ))}
          </div>
        </div>
      </Form>
    </>
  );
};

export default AddCustomerSales;
